import React, { useState, useEffect, useRef } from 'react';

import EpisodeCard from '../episode-card/EpisodeCard';
import Spinner from '../spinner/Spinner';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';

import {
  RowContainer,
  RowTitle,
  Header,
  ButtonContainer
} from './EpisodeRow.styles';

const PodcastRow = ({ title, categoryId, podcastID }) => {
  const id = podcastID ? podcastID : categoryId;
  const [data, setData] = useState(JSON.parse(sessionStorage.getItem(id)));
  const [loading, setLoading] = useState(true);

  const [scroll, setScroll] = useState(0);
  const [width, setWidth] = useState({ outer: 0, inner: 0, card: 0 });

  const containerRef = useRef();

  function getWidth() {
    if (containerRef.current) {
      const { scrollWidth, clientWidth } = containerRef.current;
      setWidth({ outer: scrollWidth, inner: clientWidth, card: 230 });
    }
  }

  // Set width information on load
  useEffect(() => {
    getWidth();
  }, [data]);

  // Set scroll position
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = scroll;
    }
  });

  // Function to determine scroll amount based on width of container
  const handleClick = e => {
    const { name } = e.target;
    const shift = Math.floor(width.inner / width.card) * width.card;
    if (name === 'left' && scroll > 0) {
      if (width.outer === scroll) {
        const total = scroll - width.inner - shift;
        setScroll(total < 0 ? 0 : total);
      } else if (scroll - shift < 0) {
        setScroll(0);
      } else {
        setScroll(scroll - shift);
      }
    }
    if (name === 'right' && scroll < width.outer) {
      if (scroll + shift > width.outer - width.inner) {
        setScroll(width.outer);
      } else {
        setScroll(scroll + shift);
      }
    }
  };

  // Check if rows data is stored inside local storage if not start fetching
  useEffect(() => {
    if (data) {
      setLoading(false);
    } else {
      const fetchData = async () => {
        let url = `/.netlify/functions/listennotes?url=`;
        podcastID
          ? (url += `/podcasts/${podcastID}/recommendations`)
          : (url += `/best_podcasts?genre_id=${categoryId}`);
        const res = await fetch(url);
        const dataObject = await res.json();
        setData(dataObject);
        setLoading(false);
        sessionStorage.setItem(id, JSON.stringify(dataObject));
      };
      fetchData().catch(err => console.error(err));
      setLoading(true);
    }
  }, [categoryId, data, id, podcastID]);

  if (loading && !data) return <Spinner />;

  // Recommended podcast data in state gets saved with property podcasts or recommendations
  const lookFor = podcastID ? 'recommendations' : 'podcasts';
  return (
    <div>
      <Header hasTitle={!!title}>
        {title && <RowTitle>{title}</RowTitle>}
        {width.outer !== width.inner && (
          <ButtonContainer>
            <button name="left" onClick={handleClick} disabled={scroll === 0}>
              <MdKeyboardArrowLeft />
            </button>
            <button
              name="right"
              onClick={handleClick}
              disabled={scroll > width.outer - width.inner}
            >
              <MdKeyboardArrowRight />
            </button>
          </ButtonContainer>
        )}
      </Header>
      {data && (
        <RowContainer ref={containerRef}>
          {data[lookFor].slice(0, 15).map(podcast => (
            <EpisodeCard key={podcast.id} podcast={podcast} />
          ))}
        </RowContainer>
      )}
    </div>
  );
};

export default PodcastRow;
